import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Navbar from './Navbar';
import { API_ENDPOINTS } from '../config/api';

const plans = [
  {
    id: 'starter',
    name: 'Starter',
    price: 9.99,
    priceId: 'price_1Sn3813Jbfj8abhvxA3rRXnC', // ✅ REAL Stripe PRICE ID
    features: [
      '100 minutes/month',
      '50 PLU',
      'Basic analytics (monthly summary)'
    ]
  },
  {
    id: 'professional',
    name: 'Professional',
    price: 19.99,
    priceId: 'price_1Sn39C3Jbfj8abhvbOsdKjsT', // ✅ REAL Stripe PRICE ID
    features: [
      '500 minutes/month',
      '200 PLU',
      'Advanced analytics (weekly insights)'
    ],
    popular: true
  },
  {
    id: 'enterprise',
    name: 'Enterprise',
    price: 49.99,
    priceId: 'price_1Sn39i3Jbfj8abhvZc1V1oA1', // ✅ REAL Stripe PRICE ID
    features: [
      'Unlimited minutes',
      'Unlimited PLU',
      'Comprehensive analytics (real-time insights)'
    ]
  }
];

function Step3PlanSelection({ userData, setUserData }) {
  const navigate = useNavigate();
  const [loadingPlanId, setLoadingPlanId] = useState(null);

  const getToken = () => localStorage.getItem('token');

  useEffect(() => {
    const token = getToken();
    console.log('🔍 Token found:', token ? 'YES' : 'NO');

    if (!token) {
      toast.error('Please login first');
      window.location.href = '/login';
    }
  }, [navigate]);

  const handlePlanSelect = async (plan) => {
    const token = getToken();
    if (!token) {
      toast.error('Please login again');
      return;
    }

    setLoadingPlanId(plan.id);  // Track THIS plan only
    try {
      const response = await fetch(API_ENDPOINTS.createSubscriptionAuto, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ priceId: plan.priceId })
      });

      const data = await response.json();

      if (response.ok && data.checkoutUrl) {
        if (window.Flutter) {
          window.Flutter.postMessage(JSON.stringify({
            type: 'OPEN_STRIPE',
            url: data.checkoutUrl
          }));
          toast.success('Redirecting to payment...');
        } else {
          window.location.href = data.checkoutUrl;
        }
      } else {
        toast.error(data.error || 'Subscription failed');
      }
    } catch (error) {
      toast.error('Server error');
    } finally {
      setLoadingPlanId(null);  // Reset THIS plan
    }
  };


  return (
    <>
      <Navbar />
      <section className="py-5">
        <div className="container">
          <div className="row mb-5 text-center">
            <div className="col-12">
              <h2 className="fw-bold mb-3">Simple, Transparent Pricing</h2>
              <p className="text-muted lead">Choose the plan that best fits your business needs.</p>
            </div>
          </div>

          <div className="row g-4">
            {plans.map((plan) => (
              <div key={plan.id} className="col-md-4">
                <div className={`pricing-card ${plan.popular ? 'featured' : ''}`}>
                  <h4 className="fw-bold mb-3">{plan.name}</h4>
                  <div className="price">
                    ${plan.price}
                    <span>/month</span>
                  </div>
                  <ul className="list-unstyled mt-3 mb-4">
                    {plan.features.map((feature, i) => (
                      <li key={i} className="mb-2">
                        <i className="bi bi-check-circle-fill text-success me-2"></i>
                        {feature}
                      </li>
                    ))}
                  </ul>
                  <button
                    onClick={() => handlePlanSelect(plan)}
                    disabled={loadingPlanId !== null}  // All buttons disabled during ANY load
                    className={`btn ${plan.popular ? 'btn-outline-primary' : 'btn-outline-primary'} w-100 btn-lg`}
                  >
                    {loadingPlanId === plan.id ? (  // Spinner ONLY on CLICKED button
                      <>
                        <span className="spinner-border spinner-border-sm me-2"></span>
                        Processing...
                      </>
                    ) : (
                      'Get Started'
                    )}
                  </button>

                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export default Step3PlanSelection;
